
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"24","viewBox":"0 0 512 512","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M160 265H84c-8.284 0-15 6.716-15 15s6.716 15 15 15h76c8.284 0 15-6.716 15-15s-6.716-15-15-15zM160 201H84c-8.284 0-15 6.716-15 15s6.716 15 15 15h76c8.284 0 15-6.716 15-15s-6.716-15-15-15zM308 137H84c-8.284 0-15 6.716-15 15s6.716 15 15 15h224c8.284 0 15-6.716 15-15s-6.716-15-15-15zM308 81H84c-8.284 0-15 6.716-15 15s6.716 15 15 15h224c8.284 0 15-6.716 15-15s-6.716-15-15-15z"}}),_c('path',{attrs:{"d":"M470.128 241H383V63.31C383 28.401 354.6 0 319.69 0H72.31C37.4 0 9 28.401 9 63.31v344.679C9 465.341 55.659 512 113.011 512H428c41.355 0 75-33.645 75-75V273.873C503 255.747 488.254 241 470.128 241zM113.011 482C72.201 482 39 448.799 39 407.989V63.31C39 44.943 53.942 30 72.31 30h247.38C338.058 30 353 44.943 353 63.31V437c0 16.871 5.603 32.456 15.041 45zM473 437c0 24.813-20.187 45-45 45s-45-20.187-45-45V271h87.128a2.876 2.876 0 012.872 2.873z"}}),_c('path',{attrs:{"d":"M283.128 303.722c-2.518-.89-5.08-1.814-7.646-2.765v-46.403c9.024 3.502 9.652 7.984 17.606 7.984 13.346 0 20.018-16.262 10.535-25.64.3-.325-11.506-10.097-28.142-13.453v-7.976c0-8.284-6.716-15-15-15s-15 6.716-15 15v9.018c-40.656 10.68-49.164 62.435-22.165 83.612 5.768 4.524 12.787 8.672 22.165 12.979v61.903c-6.504-.959-11.447-3.22-19.27-8.338-6.935-4.535-16.229-2.592-20.765 4.341-4.535 6.933-2.592 16.229 4.341 20.765 13.511 8.839 23.351 12.24 35.693 13.381v8.984c0 8.284 6.716 15 15 15s15-6.716 15-15v-10.375c52.459-13.322 62.756-88.538 7.648-108.017zm-37.647-16.64a51.034 51.034 0 01-3.65-2.589c-6.395-5.016-5.44-19.968 3.65-27.341zm30 92.515V332.94c21.89 9.498 16.659 36.799 0 46.657z"}})])
          )
        }
      }
    